// providers/UIProvider.js
'use client';

import { useEffect, useRef, useState, useMemo } from 'react';
import SupportModal from '@/components/Organisms/Modals/SupportModal';
import UserWorkspaceSideNavbar from '@/components/Organisms/Nav/UserWorkspaceSideNavbar';
import Alert from '@/components/Atoms/Alerts/Alert';
import { UIContext } from '@/contexts/UIContext';
import { usePathname } from 'next/navigation';
import MainNavbar_2 from '@/components/Organisms/Nav/MainNavbar_2';
import NotificationsModal from '@/components/Organisms/Modals/NotificationsModal';
import { getData } from '@/utils/frontend/dataOps';
import Hint from '@/components/Atoms/Alerts/Hint';
import ChatModal from '@/components/Organisms/Modals/ChatModal';
import Loading from '@/components/Atoms/Alerts/Loading';


export default function ClientUIProvider({ user, lang, children }) {


  // added / removed states must be reflected in '@/contexts/UIContext'
  const pathname = usePathname()
  const [supportModalOpen, setSupportModalOpen] = useState(false);
  const [notificationsModalOpen, setNotificationsModalOpen] = useState(false);
  const [chatNotificationsModalOpen, setChatNotificationsModalOpen] = useState(false);
  const [chatModalOpen, setChatModalOpen] = useState(false);
  const [appNotificationsArr, setAppNotificationsArr] = useState([])
  const [chatNotificationsArr, setChatNotificationsArr] = useState([])
  const [success, setSuccess] = useState(false)
  const [error, setError] = useState(false)
  const [loading, setLoading] = useState(false)
  const [hint, setHint] = useState(false)
  const [thisUser, setThisUser] = useState(user)
  const [actor, setActor] = useState()
  const [sideNavbarPinned, setSideNavbarPinned] = useState(false) // workspace navbar
  const [sideNavbarHovering, setSideNavbarHovering] = useState(false) // workspace navbar
  const fetchedRef = useRef(false);




  /*-----------------------------------------------------
    Notifications
  -------------------------------------------------------*/
  const getNotifications = async () => {

    let notificationsRes = await getData(`notifications?user_type=${user.user_type}`, 'no-store', 'include', undefined, undefined, 'getNotifications@ClientUIProvider');
    notificationsRes = notificationsRes?.data?.reverse()

    // only pass visible notifications
    let visibleNotifications, visibleAppNotifications, visibleChatNotifications;
    if (notificationsRes){
      visibleNotifications = notificationsRes.filter(n => n.notification_status !== 'DELETED');
      visibleAppNotifications = visibleNotifications.filter(n => n.notification_target_type !== 'CHAT')
      visibleChatNotifications = visibleNotifications.filter(n => n.notification_target_type === 'CHAT')
      setAppNotificationsArr([...visibleAppNotifications])
      setChatNotificationsArr([...visibleChatNotifications])
    }
    else {
      setAppNotificationsArr([])
      setChatNotificationsArr([])
    }

        // // Assume the environment variable is set correctly in your environment configuration
        // const baseUrl = process.env.NODE_ENV === 'development' ? 'http://localhost:3000' : 'https://talnet.co';
        // try {
        //     const response = await fetch(`${baseUrl}/api/notifications?user_type=${user.user_type}`, {
        //         method: 'GET',
        //         headers: {
        //             'Accept': '*/*',
        //             'Content-Type': 'application/json'
        //         },
        //         credentials: 'include', // Necessary for cookies if API is on the same domain
        //     });
        //     if (!response.ok) {
        //         throw new Error('Network response was not ok');
        //     }
        //     const data = await response.json();
        //     console.log("DATA@GETNOTIFICATIONS@CLIENTUIPROVIDER", data)
        //     // setRecordsTable(data.data?.reverse());
        //     // setSubmissionsToRender(data.data);
        //     // console.log("DATA@admin/page.js", data); // Log to see what the data looks like
        // } catch (error) {
        //     console.error('Failed to fetch notifications:', error);
        // }
        // finally {
        //     // setDataGridDataLoading(false)
        // }
       

  }

  const markNotificationsAsSeen = async (notificationUUID) => {

     try {
     //    ?id=${target.id}
     let apiUrl = `/api/notifications/${notificationUUID}?user_type=${user.user_type}&new_notification_status=SEEN`


          let response = await fetch(apiUrl, {
          method: 'PUT', // if deleting comment, PUT, if deleting post, PUT as well
          headers: {
            'Accept': '*/*',
            'Content-Type': 'application/json'
          },
          credentials: 'include', // If you are sending cookies with a cross-origin request, use 'include'
          // body: JSON.stringify({data: data, tags: {PRIMARY: selectedPrimaryTags, SECONDARY: selectedSecondaryTags}, user: user}), // Convert the credentials object to a JSON string
          // body: data
        });

        response = await response.json()
        console.log('handleDeleteResponse', response)
      if (response.success === true ) {
        // setSuccess({message: 'The notification has been deleted.'})

     //    setLoading(false)
      }
      else { 
        // setError({message: 'There was a problem deleting this notification.'})
     //    setLoading(false)
      }
      // callback({refreshData: true})

            
        } catch (error) {
          console.log('error', error)
          // setLoading(false)
        }

  }


// v2
useEffect(() => {
  if (!notificationsModalOpen && !chatNotificationsModalOpen) return;

  const timeout = setTimeout(async () => {
    const unseenApp = appNotificationsArr.filter(
      n =>
        n.notification_status !== "READ" &&
        n.notification_status !== "SEEN"
    );

    const unseenChat = chatNotificationsArr.filter(
      n =>
        n.notification_status !== "READ" &&
        n.notification_status !== "SEEN"
    );

    if (unseenApp.length === 0 && unseenChat.length === 0) return;

    await Promise.all([
      ...unseenApp.map(n =>
        markNotificationsAsSeen(n.notification_uuid)
      ),
      ...unseenChat.map(n =>
        markNotificationsAsSeen(n.notification_uuid)
      )
    ]);
  }, 1000);

  return () => clearTimeout(timeout);
}, [
  notificationsModalOpen,
  chatNotificationsModalOpen
]);

  // v1
  // useEffect(() => {
  //   const init = async () => {
  //     // await getNotifications()
  //   }
  //   init();

  //   // mark notifications as seen
  //   if (notificationsModalOpen === true){
  //   const timeout = setTimeout(async () => {
  //     const unseenApp = appNotificationsArr.filter(
  //       n => n.notification_status !== "READ" && n.notification_status !== 'SEEN'
  //     );
  //     const unseenChat = chatNotificationsArr.filter(
  //       n => n.notification_status !== "READ" && n.notification_status !== 'SEEN'
  //     );

  //     if (unseenApp.length === 0 && unseenChat.length === 0) return;

  //     await Promise.all(
  //       unseenApp.map(n =>
  //         markNotificationsAsSeen(n.notification_uuid)
  //       )
  //     );
  //     await Promise.all(
  //       unseenChat.map(n =>
  //         markNotificationsAsSeen(n.notification_uuid)
  //       )
  //     );
  //   }, 1000);

  //   return () => clearTimeout(timeout);}
  // }, [notificationsModalOpen, chatNotificationsModalOpen])


  // notifications v3 - Refresh when the user comes back to the tab combined with polling every 15 seconds
  useEffect(() => {

    if (!user || (user.user_type !== 'RECRUITER' && user.user_type !== 'EMPLOYER' && user.user_type !== 'ROOT')) return;
    // only get notifications in /workspace
    // if (!pathname.startsWith('/workspace')) return;

    // Initial fetch
    getNotifications();

    // Poll every 15s
    const interval = setInterval(() => {
      getNotifications();
    }, 15000);

    // Refresh immediately when user refocuses tab
    const handleFocus = () => {
      getNotifications();
    };

    window.addEventListener('focus', handleFocus);

    // Cleanup when leaving workspace
    return () => {
      clearInterval(interval);
      window.removeEventListener('focus', handleFocus);
    };
}, [pathname]);


  // notifications v2 (user has to leave workspace for notifications to refresh)
  // useEffect(() => {
  //   if (!pathname.startsWith('/workspace')) {
  //     fetchedRef.current = false; // reset when leaving
  //     setSupportModalOpen(false);
  //     setNotificationsModalOpen(false);
  //     return;
  //   }

  //   if (fetchedRef.current) return;

  //   fetchedRef.current = true;
  //   getNotifications();
  // }, [pathname]);





// notifications v1 
// useEffect(() => {
//     if (!pathname.startsWith('/workspace')) {
//       setSupportModalOpen(false);
//       setNotificationsModalOpen(false);
//       return;
//     }
//     // if already fetched while in /workspace*, don't fetch again
//     if (fetchedRef.current) return;

//     fetchedRef.current = true;
//     getNotifications();
//   // if (!pathname.startsWith('/workspace')) return;
  
//   // getNotifications();
// }, [pathname]);





/*===============================
---Logging              START
===============================*/
// const logPageVisit = async () => {
//   // if (user) {
//           try {
//             let logsApiUrl = `/api/services/logs?user_type=${user.user_type}`
//             let response = await fetch(logsApiUrl, {
//             method: `${'POST'}`,
//             headers: {
//               'Accept': '*/*',
//               'Content-Type': 'application/json'
//             },
//             credentials: 'include', // If you are sending cookies with a cross-origin request, use 'include'
//             body: JSON.stringify({
//               data: {
//                 target_type: 'SYSTEM',
//                 action: 'NAVIGATION_PAGE_VISITED',
//                 domain: 'NAVIGATION',
//                 context: {page_url: window.location.href}
//               }, 
//             user: user}), // Convert the credentials object to a JSON string
//             // body: data
//           });

//         response = await response.json()
//         console.log('handleSubmitResponse', response)

//       if (response.success) {
//         console.log("Success logging!")
//       }
//       else { 
//         console.log("Error logging!")
//       }

            
//         } catch (error) {
//           console.error('error:', error)
//         }
// // }
// }

// useEffect(() => {

//   if (!user || (user.user_type !== 'RECRUITER' && user.user_type !== 'EMPLOYER' && user.user_type !== 'ROOT')) return;
//   // only get notifications in /workspace
//   // if (!pathname.startsWith('/workspace')) return;

//   // Initial log
//   const init = async () =>{  await logPageVisit()}
//   init();

//   // Initial fetch
//   // getNotifications();

//   // Poll every 15s
//   // const interval = setInterval(() => {
//   //   getNotifications();
//   // }, 15000);

//   // Refresh immediately when user refocuses tab
//   // const handleFocus = () => {
//   //   getNotifications();
//   // };

//   // window.addEventListener('focus', handleFocus);

//   // Cleanup when leaving workspace
//   // return () => {
//   //   clearInterval(interval);
//   //   window.removeEventListener('focus', handleFocus);
//   // };
// }, [pathname]);

/*===============================
---Logging              END
===============================*/




  /*---------------------------------------
    This user data
  ----------------------------------------*/
  const getThisUserData = async () => {
      if (!user) { return; }
        let thisUserData = await getData(`users/${user.user_uuid}?user_type=${user.user_type}`, 'no-store', 'include', undefined, undefined, 'getThisUser@ClientUIProvider');
        setThisUser(thisUserData.data)
        // console.log("THISUSER@CLIENTUIPROVIDER", thisUserData.data)
  }

    useEffect(() => {
    // Only fetch if in /workspace or in /feed or in /posts and user exists
    if ((!pathname.startsWith('/workspace') && !pathname.startsWith('/feed') && !pathname.startsWith('/posts')) || !user) return;

    // Reset ref on every new session (optional)
    fetchedRef.current = false;

    // // Fetch user data
    // getThisUserData();

    // // Mark fetched (so subsequent pathname changes inside /workspace don't refetch unnecessarily)
    // fetchedRef.current = true;


      // Reset ref on every new session (optional)

  const init = async () => {
    try {
      await getThisUserData();
      // Only mark as fetched after it actually succeeds
      fetchedRef.current = true;
    } catch (error) {
      console.error('Failed to fetch user data:', error);
    }
  };

  init();

  }, [pathname, user]);

  // useEffect(() => {
  //   if (!pathname.startsWith('/workspace')) {
  //           fetchedRef.current = false; // reset when leaving
  //           return;
  //   }

  //     // if already fetched while in /workspace*, don't fetch again
  //     if (fetchedRef.current) return;

  //     fetchedRef.current = true;
  //     getThisUserData();
  //   // if (!pathname.startsWith('/workspace')) return;
    
  //   // getNotifications();
  // }, [pathname, user]);



  


  /*-----------------------------------------------------
    Control where navbars are visible and how they behave
  -------------------------------------------------------*/
  let userSideNavbarVisible = false
  // const mainNavbar = {isVisible: true, isFixed: true}
  // let mainNavbar = {
  //   isVisible: true,
  //   // isVisible: !pathname.startsWith('/admin') && !pathname.startsWith('/workspace'),
  //   isFixed: !pathname.startsWith('/social'),
  // };
  const mainNavbar = useMemo(() => {
  const isFixed = !pathname.startsWith('/feed') && !pathname.startsWith('/posts');
  const isVisible = true; // or put your pathname logic here if needed

  return { isFixed, isVisible };
}, [pathname]);

  if (pathname.startsWith('/admin') || pathname.startsWith('/workspace')) {
    userSideNavbarVisible = true
  }



  /*-----------------------------------------------------
    Callbacks
  -------------------------------------------------------*/
    const handleNavCallback = (callback) => {
    // console.log('navCallback@clientUIProvider', callback)
    if (!callback) { return ;}
      if (callback.sideNavbarPinned !== undefined) {setSideNavbarPinned(callback.sideNavbarPinned)}
      if (callback.sideNavbarHovering !== undefined) {setSideNavbarHovering(callback.sideNavbarHovering)}
//     if (callback.jobModalOpen) {setJobModalOpen(callback.jobModalOpen)}
    // if (callback.bulletinModalOpen) {setBulletinModalOpen(callback.bulletinModalOpen)}
//     if (callback.tagsModalOpen) {setTagsModalOpen(callback.tagsModalOpen)}
//     if (callback.talentModalOpen) {setTalentModalOpen(callback.talentModalOpen)}
//     if (callback.campaignModalOpen) {setCampaignModalOpen(callback.campaignModalOpen)}
    if (callback.supportModalOpen) {
      setSupportModalOpen(callback.supportModalOpen)
      // setTimeout(() => {
      //   notificationsArr.map(n => n.notification_status = 'SEEN')
      // }, 500);
    }
      if (callback.notificationsModalOpen) {setNotificationsModalOpen(callback.notificationsModalOpen)}
      if (callback.chatNotificationsModalOpen) {setChatNotificationsModalOpen(callback.chatNotificationsModalOpen)}
}

const handleNotificationModalCallback = async cb => {
  if(cb.refreshData) {
    await getNotifications()
  }
}


  return (
    <>
      <UIContext.Provider
        value={{
          thisUser, setThisUser,
          actor, setActor,
          supportModalOpen, setSupportModalOpen,
          chatModalOpen, setChatModalOpen,
          notificationsModalOpen, setNotificationsModalOpen, // used for chat + app notifications
          chatNotificationsModalOpen, setChatNotificationsModalOpen,
          success, setSuccess,
          error, setError,
          hint, setHint,
          loading, setLoading,
          sideNavbarPinned, setSideNavbarPinned, // workspace navbar
          sideNavbarHovering, setSideNavbarHovering, // workspace navbar
          handleNavCallback
        }}
      >


     <Alert message={success ? success.message : error ? error.message : ''} state={{success: success, setSuccess: setSuccess, error: error, setError: setError}}/>
    <Hint state={{hint:hint, setHint: setHint}} message={hint?.message}/>
{loading && <Loading lang={lang}/>  }


    <MainNavbar_2 
      user={user} 
      lang={lang} 
      parent={'LANG'} 
      mainNavbarVisible={mainNavbar.isVisible} 
      mainNavbarFixed={mainNavbar.isFixed}
      appNotificationsArr={appNotificationsArr || []}
      chatNotificationsArr={chatNotificationsArr || []}
      callback={handleNavCallback}
      // mainNavbarVisible={true}
      // mainNavbarFixed={true}
    />

    {(userSideNavbarVisible && user && (user.user_type === 'EMPLOYER' || user.user_type === 'RECRUITER' || user.user_type==='ROOT')) && 
      <UserWorkspaceSideNavbar appNotificationsArr={appNotificationsArr || []} chatNotificationsArr={chatNotificationsArr || []} mainNavbarVisible={mainNavbar.isVisible} callback={handleNavCallback} user={user} lang={lang || 'en'}/>
    }
     
    <SupportModal
      user={user}
      lang={lang}
      callback={()=>handleChildCallback}
      modalHeaderCaption={lang === 'fr' ? 'Demande de Support ou de Fonctionnalité' : 'Request Support or Functionality' }
      state={{supportModalOpen: supportModalOpen, setSupportModalOpen: setSupportModalOpen, error: error, setError: setError, success: success, setSuccess: setSuccess}}
    />

    <NotificationsModal

      displayMode = {chatNotificationsModalOpen ? 'CHAT_NOTIFICATIONS' : 'APP_NOTIFICATIONS'}
      data={chatNotificationsModalOpen ? chatNotificationsArr : notificationsModalOpen ?  appNotificationsArr : []}
      user={user}
      lang={lang}
      callback={cb=>handleNotificationModalCallback(cb)}
      modalHeaderCaption={notificationsModalOpen ? <>  <i className="fa-regular fa-bell"></i> Your notifications</> : 
        <>  <i className="fa-regular fa-envelope"></i> Your messages</>
       }
      state={{chatNotificationsModalOpen: chatNotificationsModalOpen, setChatNotificationsModalOpen: setChatNotificationsModalOpen, notificationsModalOpen: notificationsModalOpen, setNotificationsModalOpen: setNotificationsModalOpen, error: error, setError: setError, success: success, setSuccess: setSuccess}}
    />

    {/* <ChatModal captionToShare={''} hrefToShare={``} modalHeaderCaption={'Share this post'} state={{chatModalOpen, setChatModalOpen}} target={'post'}/> */}

      {children}
      </UIContext.Provider>
    </>
  );
}
























// // providers/UIProvider.js
// 'use client';

// import { useEffect, useRef, useState } from 'react';
// import SupportModal from '@/components/Organisms/Modals/SupportModal';
// import UserWorkspaceSideNavbar from '@/components/Organisms/Nav/UserWorkspaceSideNavbar';
// import Alert from '@/components/Atoms/Alerts/Alert';
// import { UIContext } from '@/contexts/UIContext';
// import { usePathname } from 'next/navigation';
// import MainNavbar_2 from '@/components/Organisms/Nav/MainNavbar_2';
// import NotificationsModal from '@/components/Organisms/Modals/NotificationsModal';
// import { getData } from '@/utils/frontend/dataOps';
// import Hint from '@/components/Atoms/Alerts/Hint';


// export default function ClientUIProvider({ user, lang, children }) {



//   // added / removed states must be reflected in '@/contexts/UIContext'
//   const pathname = usePathname()
//   const [supportModalOpen, setSupportModalOpen] = useState(false);
//     const [notificationsModalOpen, setNotificationsModalOpen] = useState(false);
//     const [notificationsArr, setNotificationsArr] = useState([])
//   const [success, setSuccess] = useState(false)
//   const [error, setError] = useState(false)
//     const [hint, setHint] = useState(false)
//     const [thisUser, setThisUser] = useState(user)
//     const [actor, setActor] = useState()
//   const [sideNavbarPinned, setSideNavbarPinned] = useState(true)
// const fetchedRef = useRef(false);


//   /*-----------------------------------------------------
//     Notifications
//   -------------------------------------------------------*/
//   const getNotifications = async () => {

//     let notificationsRes = await getData(`notifications?user_type=${user.user_type}`, 'no-store', 'include', undefined, undefined, 'getNotifications@ClientUIProvider');
//     notificationsRes = notificationsRes?.data?.reverse()

//     // only pass visible notifications
//     const visibleNotifications = notificationsRes.filter(n => n.notification_status !== 'DELETED');
//     setNotificationsArr([...visibleNotifications])
//         // // Assume the environment variable is set correctly in your environment configuration
//         // const baseUrl = process.env.NODE_ENV === 'development' ? 'http://localhost:3000' : 'https://talnet.co';
//         // try {
//         //     const response = await fetch(`${baseUrl}/api/notifications?user_type=${user.user_type}`, {
//         //         method: 'GET',
//         //         headers: {
//         //             'Accept': '*/*',
//         //             'Content-Type': 'application/json'
//         //         },
//         //         credentials: 'include', // Necessary for cookies if API is on the same domain
//         //     });
//         //     if (!response.ok) {
//         //         throw new Error('Network response was not ok');
//         //     }
//         //     const data = await response.json();
//         //     console.log("DATA@GETNOTIFICATIONS@CLIENTUIPROVIDER", data)
//         //     // setRecordsTable(data.data?.reverse());
//         //     // setSubmissionsToRender(data.data);
//         //     // console.log("DATA@admin/page.js", data); // Log to see what the data looks like
//         // } catch (error) {
//         //     console.error('Failed to fetch notifications:', error);
//         // }
//         // finally {
//         //     // setDataGridDataLoading(false)
//         // }
       

//   }

//   const markNotificationsAsSeen = async (notificationUUID) => {

//      try {
//      //    ?id=${target.id}
//      let apiUrl = `/api/notifications/${notificationUUID}?user_type=${user.user_type}&new_notification_status=SEEN`


//           let response = await fetch(apiUrl, {
//           method: 'PUT', // if deleting comment, PUT, if deleting post, PUT as well
//           headers: {
//             'Accept': '*/*',
//             'Content-Type': 'application/json'
//           },
//           credentials: 'include', // If you are sending cookies with a cross-origin request, use 'include'
//           // body: JSON.stringify({data: data, tags: {PRIMARY: selectedPrimaryTags, SECONDARY: selectedSecondaryTags}, user: user}), // Convert the credentials object to a JSON string
//           // body: data
//         });

//         response = await response.json()
//         console.log('handleDeleteResponse', response)
//       if (response.success === true ) {
//         // setSuccess({message: 'The notification has been deleted.'})

//      //    setLoading(false)
//       }
//       else { 
//         // setError({message: 'There was a problem deleting this notification.'})
//      //    setLoading(false)
//       }
//       // callback({refreshData: true})

            
//         } catch (error) {
//           console.log('error', error)
//           // setLoading(false)
//         }

//   }


//   /*---------------------------------------
//     This user data
//   ----------------------------------------*/
//   const getThisUserData = async () => {
//       if (!user) { return; }
//         let thisUserData = await getData(`users/${user.user_uuid}?user_type=${user.user_type}`, 'no-store', 'include', undefined, undefined, 'getUsers@ClientUIProvider');
//         setThisUser(thisUserData.data)
//   }

 
// useEffect(() => {
//   const init = async () => {
//     // await getNotifications()
//   }
//   init();

//   // mark notifications as seen
//   if (notificationsModalOpen === true){
//   const timeout = setTimeout(async () => {
//     const unseen = notificationsArr.filter(
//       n => n.notification_status !== "READ" && n.notification_status !== 'SEEN'
//     );

//     if (unseen.length === 0) return;

//     await Promise.all(
//       unseen.map(n =>
//         markNotificationsAsSeen(n.notification_uuid)
//       )
//     );
//   }, 1000);

//   return () => clearTimeout(timeout);}
// }, [notificationsModalOpen])


// // notifications 
// useEffect(() => {
//     if (!pathname.startsWith('/workspace')) {
//       setSupportModalOpen(false);
//       setNotificationsModalOpen(false);
//       return;
//     }
//     // if already fetched while in /workspace*, don't fetch again
//     if (fetchedRef.current) return;

//     fetchedRef.current = true;
//     getNotifications();
//   // if (!pathname.startsWith('/workspace')) return;
  
//   // getNotifications();
// }, [pathname]);

// // this user data
// useEffect(() => {
//     // if (!pathname.startsWith('/workspace')) {
//     //   setSupportModalOpen(false);
//     //   setNotificationsModalOpen(false);
//     //   return;
//     // }
//     // if already fetched while in /workspace*, don't fetch again
//     if (fetchedRef.current) return;

//     fetchedRef.current = true;
//     getThisUserData();
//   // if (!pathname.startsWith('/workspace')) return;
  
//   // getNotifications();
// }, [pathname]);


//   /*-----------------------------------------------------
//     Control where navbars are visible and how they behave
//   -------------------------------------------------------*/
//   let userSideNavbarVisible = false
//   // const mainNavbar = {isVisible: true, isFixed: true}
//   let mainNavbar = {
//     isVisible: true,
//     // isVisible: !pathname.startsWith('/admin') && !pathname.startsWith('/workspace'),
//     isFixed: !pathname.startsWith('/social'),
//   };

//   if (pathname.startsWith('/admin') || pathname.startsWith('/workspace')) {
//     userSideNavbarVisible = true
//   }



//   /*-----------------------------------------------------
//     Callbacks
//   -------------------------------------------------------*/
//     const handleNavCallback = (callback) => {
//     console.log('navCallback@clientUIProvider', callback)
//     if (!callback) { return ;}
//       if (callback.sideNavbarPinned !== undefined) {setSideNavbarPinned(callback.sideNavbarPinned)}

// //     if (callback.jobModalOpen) {setJobModalOpen(callback.jobModalOpen)}
//     // if (callback.bulletinModalOpen) {setBulletinModalOpen(callback.bulletinModalOpen)}
// //     if (callback.tagsModalOpen) {setTagsModalOpen(callback.tagsModalOpen)}
// //     if (callback.talentModalOpen) {setTalentModalOpen(callback.talentModalOpen)}
// //     if (callback.campaignModalOpen) {setCampaignModalOpen(callback.campaignModalOpen)}
//     if (callback.supportModalOpen) {
//       setSupportModalOpen(callback.supportModalOpen)
//       // setTimeout(() => {
//       //   notificationsArr.map(n => n.notification_status = 'SEEN')
//       // }, 500);
//     }
//       if (callback.notificationsModalOpen) {setNotificationsModalOpen(callback.notificationsModalOpen)}
// }

// const handleNotificationModalCallback = async cb => {
//   if(cb.refreshData) {
//     await getNotifications()
//   }
// }


//   return (
//     <>
//       <UIContext.Provider
//         value={{
//           thisUser, setThisUser,
//           actor, setActor,
//           supportModalOpen, setSupportModalOpen,
//           notificationsModalOpen, setNotificationsModalOpen,
//           success, setSuccess,
//           error, setError,
//           hint, setHint,
//           sideNavbarPinned, setSideNavbarPinned,
//           handleNavCallback
//         }}
//       >


//      <Alert message={success ? success.message : error ? error.message : ''} state={{success: success, setSuccess: setSuccess, error: error, setError: setError}}/>
//     <Hint state={{hint:hint, setHint: setHint}} message={hint?.message}/>


//     <MainNavbar_2 user={user} lang={lang} parent={'LANG'} 
//     mainNavbarVisible={mainNavbar.isVisible} 
//     mainNavbarFixed={mainNavbar.isFixed}
//     // mainNavbarVisible={true}
//     // mainNavbarFixed={true}
//     />

//     {(userSideNavbarVisible && user && (user.user_type === 'EMPLOYER' || user.user_type === 'RECRUITER' || user.user_type==='ROOT')) && 
//       <UserWorkspaceSideNavbar notifications={notificationsArr || []} mainNavbarVisible={mainNavbar.isVisible} callback={handleNavCallback} user={user} lang={lang || 'en'}/>
//     }
     
//     <SupportModal
//       user={user}
//       lang={lang}
//       callback={()=>handleChildCallback}
//       modalHeaderCaption={lang === 'fr' ? 'Demande de Support ou de Fonctionnalité' : 'Request Support or Functionality' }
//       state={{supportModalOpen: supportModalOpen, setSupportModalOpen: setSupportModalOpen, error: error, setError: setError, success: success, setSuccess: setSuccess}}
//     />

//     <NotificationsModal
//       data={notificationsArr || []}
//       user={user}
//       lang={lang}
//       callback={cb=>handleNotificationModalCallback(cb)}
//       modalHeaderCaption={lang === 'fr' ? 'Demande de Support ou de Fonctionnalité' : 'Request Support or Functionality' }
//       state={{notificationsModalOpen: notificationsModalOpen, setNotificationsModalOpen: setNotificationsModalOpen, error: error, setError: setError, success: success, setSuccess: setSuccess}}
//     />

//       {children}
//       </UIContext.Provider>
//     </>
//   );
// }